import React from 'react';
import '../styles/NeighborhoodSummary.css';

const NeighborhoodSummary = ({ selectedNeighborhood }) => {
  if (!selectedNeighborhood) {
    return (
      <div className="summary-placeholder">
        <p>Hover over a neighborhood to see details.</p>
      </div>
    );
  }

  const { NAME, crimeScore } = selectedNeighborhood.properties;

  const getSafetyLabelAndColor = (score) => {
    if (score >= 8) return { label: 'Very Safe 🟢', color: '#4caf50' };
    if (score >= 6) return { label: 'Moderately Safe 🟠', color: '#ff9800' };
    if (score >= 4) return { label: 'Less Safe 🔴', color: '#f44336' };
    if (score) return { label: 'Unsafe ⚠️', color: '#8B0000' };
    return { label: 'No Data ⚪', color: '#bbb' };
  };


  const safety = getSafetyLabelAndColor(crimeScore);

  return (
    <div className="neighborhood-summary">
      <h3>{NAME}</h3>
      <ul>
        <li>
          🛡️ Safety: <span style={{ color: safety.color }}>{safety.label} ({crimeScore || "N/A"})</span>
        </li>
        <li>💲 Avg Rent: $2600–$3200</li> {/* Placeholder */}
        <li>🚲 Commute: Excellent</li> {/* Placeholder */}
        <li>📅 Rental Availability: Moderate</li> {/* Placeholder */}
      </ul>
      <p className="zoom-in-message">🔎 Zoom in to see available units.</p>
    </div>
  );
};

export default NeighborhoodSummary;